import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'z-bi-dashboards',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './BI-dashboards.component.html',
  styleUrl: './BI-dashboards.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BIDashboardsComponent {}
